import api from './api';
import { 
  WhatsAppNotificationConfig, 
  CreateWhatsAppNotificationConfig, 
  UpdateWhatsAppNotificationConfig,
  NotificationStatus 
} from '../types/whatsapp';

const whatsappService = {
  async getConfigurations(): Promise<WhatsAppNotificationConfig[]> {
    const { data } = await api.get('/WhatsApp/configuraciones');
    return data;
  },

  async createConfiguration(config: CreateWhatsAppNotificationConfig): Promise<WhatsAppNotificationConfig> {
    const { data } = await api.post('/WhatsApp/configuraciones', config);
    return data;
  },

  async updateConfiguration(id: number, config: UpdateWhatsAppNotificationConfig): Promise<WhatsAppNotificationConfig> {
    const { data } = await api.put(`/WhatsApp/configuraciones/${id}`, config);
    return data;
  },

  async deleteConfiguration(id: number): Promise<void> {
    await api.delete(`/WhatsApp/configuraciones/${id}`);
  },

  async activateConfiguration(id: number): Promise<void> {
    // Enviar cuerpo vacío para evitar problemas con proxies/servidores que rechazan POST sin payload
    await api.post(`/WhatsApp/configuraciones/${id}/activar`, {});
  },

  async getNotificationStatus(): Promise<NotificationStatus> {
    const { data } = await api.get('/WhatsApp/status');
    return data;
  },

  async getMessageLogs(params: { from?: string; to?: string; estado?: 'Enviada' | 'Error' | ''; page?: number; pageSize?: number } = {})
  : Promise<{ page: number; pageSize: number; total: number; items: Array<{ id: number; tipo: string; estado: string; destinatarioNombre?: string; destinatarioNumero: string; detalle?: string; fechaEnvio: string }> }>
  {
    const { data } = await api.get(`/WhatsAppLogs/logs`, { params });
    return data;
  },

};

export default whatsappService;
